import { withDependencies } from '@wix/thunderbolt-ioc'
import { isSSR } from '@wix/thunderbolt-commons'
import { BrowserWindowSymbol } from '@wix/thunderbolt-symbols'
import type { IShouldObserveHeaderHandler } from './types'

export const ShouldObserveHeaderHandler = withDependencies(
	[BrowserWindowSymbol],
	(browserWindow): IShouldObserveHeaderHandler => {
		return {
			shouldObserveHeader: !isSSR(browserWindow),
		}
	}
)
